import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router';
import {
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Button,
  CircularProgress,
  TextField,
  withStyles,
} from '@material-ui/core';
import { useParams } from 'react-router-dom';
import {
  AvTimer,
  Code,
  Email,
  Lock,
  Visibility,
  VisibilityOff,
} from '@material-ui/icons';

import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import helper, { validateEmail, browser } from '../../utils/helper';
import Alert from '../../Components/Poper';

import service from '../../Contexts/App/AppService';
import { AppContext, SET_AUTH_ERROR, SET_RESET_SUCCESS } from '../../Contexts/App/AppContext';
import Slider from './components/Slider';
import logo from '../../assets/images/logo.svg';

const env = process.env.REACT_APP_ENV;
const regex = /^(?=.{8,32}$)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).*/;


const CssTextField = withStyles({
  root: {
    // backgroundColor: 'unset',

    // '& label.Mui-focused': {
    //   color: '##7F8C8D',
    // },
    // '& .MuiInput-underline:after': {
    //   borderBottomColor: '##7F8C8D',
    // },
    'MuiInputBase': {
      input: {
        '&:-webkit-autofill': {
          transitionDelay: '9999s',
          transitionProperty: 'background-color, color',
        },
      },
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'white !important',
      //'&.Mui-focused fieldset': {
      //     borderColor: '#7F8C8D',
      // },
    },
    // '& .MuiInputLabel-outlined': {
    //   transform: 'translate(10px, 14px) scale(1)',
    //   backgroundColor: '#EBEBEB',
    //   width: '100px'
    // },
    // '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
    //   transform: 'translate(14px, -6px) scale(0.75)',
    //   backgroundColor: 'unset',
    // },
    height: '43px',
    '& > .MuiOutlinedInput-root': {

      backgroundColor: ' #white !important',
      borderRadius: '6px',
      color: ' #7F8C8D',
      fontWeight: '500',
      marginBottom: '0px',
    },
    '& > .MuiFormControl-marginNormal': {

      marginBottom: '0px',
    },


  },
})(TextField);

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="">
        PackageX
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const AlignCenter = ({ children, style }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      padding: 10,
      ...style,
    }}
    className={'font-size-12'}
  >
    {children}
  </div>
);


const VerticallyCenter = ({ children, style, className }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      height: 'inherit',
      alignItems: 'center',
      ...style,
    }}
    className={className}
  >
    {children}
  </div>
);

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function Login(props) {
  const history = useHistory();
  const classes = useStyles();
  const appCtx = useContext(AppContext);
  const { AuthError: error, resetSuccess } = appCtx;

  const decrypt2 = text => {
    const k = '69a23d3c4e3c990d00a5bf559b4f987c3d226e18421cd7bcc67d662e0cb032a3';
    const v = 'cc670e3c7f07c85240948611bc7453c2';
    let iv = new Buffer.from(v, 'hex');
    let encryptedText = new Buffer.from(text.encryptedData, 'hex');
    const algorithm = 'aes-256-cbc';
    let decipher = crypto.createDecipheriv(
      algorithm,
      new Buffer.from(k, 'hex'),
      iv,
    );
    let decrypted = decipher.update(encryptedText);
    decrypted = Buffer.concat([decrypted, decipher.final()]);
    return decrypted.toString();
  };

  const { location } = props;
  const url_string = `http://www.example.com/login${location.search}`;
  const url = new URL(url_string);
  let emailUrl = url.searchParams.get('detail') || '';
  let passwordKey = url.searchParams.get('key');
  let passwordUrl = '';
  if (emailUrl !== null && passwordKey !== null && passwordKey.length !== 0) {
    passwordUrl = decrypt2({
      encryptedData: passwordKey,
    });
  }

  const [email, setEmail] = useState(emailUrl || '');
  const [confirmPassword, setconfirmPassword] = useState('');
  const [resetCode, setresetCode] = useState('');

  // const [error, setError] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [password, setPassword] = useState(passwordUrl);
  const [passwordError, setpasswordError] = useState(null);
  const [active, setActive] = useState(props.location.pathname.includes('reset') ? 'resetPass' : 'login');

  const [showPassword, setshowPassword] = useState(false);
  const [forceReset, setforceReset] = useState(false);
  const [confirmPassError, setconfirmPassError] = useState(false);
  const [showConfirmPass, setshowConfirmPass] = useState(false);
  const [wrongCreds, setwrongCreds] = useState(false);
  const [showTempPass, setshowTempPass] = useState(false);
  const [waiting, setwaiting] = useState(false);

  const [temporaryPass, settemporaryPass] = useState(passwordUrl);
  useEffect(() => {
  }, [])


  const params = useParams();

  const HandleSubmit = () => {


    const credentials = {
      email: email,
      password: password,
      os_info: helper.getUserOS(),
      browser_info: helper.getUserBrowser(),
      browser_version_info: helper.getUserBrowserVersion(),
      device_timezone: helper.getUserTimeZone(),
      platform: helper.getPlatform(),

    };

    if (active === 'login') {

      service.VerifyUserLogIn(credentials, appCtx, res => {
        if (
          res.status === 1
        ) { // Redirect to Dashboard

          history.push('/');
          localStorage.setItem('isFromLogin', true)
          setwaiting(false);

        } else { // Force Reset Pass

          if (res.user.code === 'NotAuthorizedException' || res.user.message.includes('does not exist')) {
            appCtx.dispatch({ type: SET_AUTH_ERROR, error: "Incorrect Username/Password" })

          }
          else if (res.user.code === 'NetworkError') {
            appCtx.dispatch({ type: SET_AUTH_ERROR, error: "Something went wrong!" })

          }
          else if (res.user.message.includes('null failed with error Generate callenges lambda cannot be called..')) {
            appCtx.dispatch({ type: SET_AUTH_ERROR, error: "Your password must be at least 8 characters long." })

          }
          else if (res.user.message.includes('execute')) {
            appCtx.dispatch({ type: SET_AUTH_ERROR, error: "Session Expired." })

          }
          else {
            appCtx.dispatch({ type: SET_AUTH_ERROR, error: "Unable to Login" })

          }

          // this.props.history.push(`/force_reset_password/${credentials.email}`);
        }
      });

    } else if (active === 'forgotPass') {
      service.sendForgotEmail(credentials, appCtx, res => {
        if (
          res.status === 1
        ) { // Redirect to Dashboard

          history.push(`/reset_password/${email}`);

        } else { // Force Reset Pass
          setwaiting(false);
          setwrongCreds(true)
          if (res.user.code === 'UserNotFoundException') {
            appCtx.dispatch({ type: SET_AUTH_ERROR, error: "User is invalid." })

          }
          else {
            appCtx.dispatch({ type: SET_AUTH_ERROR, error: res.user.message })

          }
        }
      });

    } else if (active === 'resetPass') {

      service.resetPasswordEmail({ email: params.email, resetCode: resetCode, password: password }, appCtx, res => {
        if (
          res.status === 1
        ) { // Redirect to Dashboard

          history.push(`/`);

          appCtx.dispatch({ type: SET_RESET_SUCCESS, payload: true });
          appCtx.dispatch({ type: SET_AUTH_ERROR, error: null });


        } else { // Force Reset Pass

          if (res.user.code === 'ExpiredCodeException') {
            appCtx.dispatch({ type: SET_AUTH_ERROR, error: "Incorrect Code" });
          }
          else if (res.user.message.includes("confirmationCode' failed to satisfy constraint: Member must satisfy regular expression pattern")) {
            appCtx.dispatch({ type: SET_AUTH_ERROR, error: "Reset Code should not have spaces." })
          }
          else {
            appCtx.dispatch({ type: SET_AUTH_ERROR, error: res.user.message })
          }
        }
      });

    } else if (active === 'forceReset') {
      // forceResetPassword(match.params.email, temporaryPass, password)
      //   .then(res => {
      //     let uuid;
      //     if (env && env.includes('cn')) {
      //       uuid = localStorage.px_uid;
      //     } else {
      //       uuid = res.username;
      //     }
      //     confirmUser(uuid)
      //       .then(() => {
      //         this.resetStates();
      //         this.setState({ loggedin: true, waiting: false });
      //       }).catch(err =>
      //         this.setState({
      //           waiting: false,
      //           wrongCreds: true,
      //           error:
      //             err.code === 'NotAuthorizedException'
      //               ? t('setPassword.wrongTempPassword')
      //               : err.message,
      //         }));
      //   })
      //   .catch(err => {
      //     this.setState({
      //       waiting: false,
      //       wrongCreds: true,
      //       error:
      //         err.code === 'NotAuthorizedException'
      //           ? t('setPassword.wrongTempPassword')
      //           : err.response ? err.response.data.message : err.message,
      //     });
      //   });
    }



  }

  let disabled = waiting || error || emailError || passwordError ||
    email.length === 0 || password.length === 0 || wrongCreds;
  if (active === 'forgotPass') {
    disabled = emailError || wrongCreds || waiting || email.length === 0;
  }
  if (active === 'resetPass') {
    disabled = waiting || error || passwordError || password.length === 0
      || confirmPassword.length === 0 || confirmPassError || wrongCreds;
  }
  if (active === 'forceReset') {
    disabled = waiting || error || passwordError || password.length === 0 || wrongCreds ||
      confirmPassword.length === 0 || confirmPassError || temporaryPass.length === 0;
  }

  if (browser === 'edge') {
    return <div style={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: 'bold',
      fontSize: '21'
    }}>Oops! Currently not supported on Edge.</div>
  }
  else {
    return (
      <Grid container className="height-100vh overflow-hidden">
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          {(error || resetSuccess) && (
            <Alert
              variant={error ? 'error' : 'success'}
              message={error || 'Congratulations! Your password has successfully been changed.'}
              onClose={() => {
                if (resetSuccess) {
                  appCtx.dispatch({ type: SET_RESET_SUCCESS, payload: false });
                }
                else {
                  appCtx.dispatch({ type: SET_AUTH_ERROR, error: null })
                }
              }}
              open
            />
          )}
          <Paper elevation={0} className="padding-3246 height-width-p height-100v">
            <a target="__blank" href="https://packagex.app/inventory" >
              <img className="logo" src={logo} alt="logo" />
            </a>
            <div className="height-login">
              <VerticallyCenter>
                <div className="margin-070">
                  <form
                    onSubmit={e => {
                      e.preventDefault();
                      HandleSubmit()

                    }}
                  >
                    <div className="align-center-100">
                      <h3 className="heading">Welcome to PackageX Inventory</h3>
                    </div>
                    <div className="align-center-100">
                      <p className="black padding-top-10p padding-bottom-30p font-size-16 login-text-img">The inventory management solution from the future</p>
                    </div>
                    {(active === 'resetPass') &&
                      <div className="form__form-group">
                        <FormControl required fullWidth className="height-75" autocomplete={false}>
                          <CssTextField
                            variant="outlined"
                            margin="normal"
                            className="resetCodeStyle"
                            value={resetCode}
                            required
                            danger={error || wrongCreds}
                            id="resetCode"
                            label="Reset Code"
                            // name="resetCode"
                            required
                            fullWidth
                            autoFocus
                            autocomplete={false}
                            onChange={(e) => setresetCode(e.target.value)}
                            // placeholder={t('setPassword.resetCode')}
                            InputProps={{
                              startAdornment: <InputAdornment position="start">
                                <Code className="black" />
                              </InputAdornment>,
                            }}

                          />
                        </FormControl>
                      </div>}
                    {(active === 'login' || active === 'forgotPass') &&
                      <div className="form__form-group">
                        <FormControl
                          required
                          fullWidth
                          className="height-75"
                          onBlur={() => {
                            if (email.length > 0) {
                              setEmailError(!validateEmail(email))
                            }
                          }}
                        >

                          <CssTextField
                            variant="outlined"
                            margin="normal"
                            value={email}
                            onChange={event => setEmail(event.target.value)}
                            required
                            fullWidth
                            id="email"
                            label="Email Address"
                            name="email"
                            autoComplete="email"
                            autoFocus
                            InputProps={{
                              startAdornment:
                                <InputAdornment position="start">
                                  <Email className="black" />
                                </InputAdornment>
                            }}

                          />

                          {emailError && (
                            <FormHelperText className="font-size-10 red-color">
                              {"Please enter a valid email address."}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </div>}

                    {active === 'forceReset' &&
                      <FormControl required fullWidth className="height-75">

                        <CssTextField
                          autocomplete="foo"
                          type={showTempPass ? 'text' : 'password'}
                          value={temporaryPass}
                          danger={wrongCreds}
                          inputProps={{ autocomplete: 'password' }}
                          onChange={(e) => settemporaryPass(e.target.value)}
                          // placeholder={t('setPasswordForce.temporary')}
                          InputProps={{
                            startAdornment: <InputAdornment position="start">
                              <AvTimer className="black" />
                            </InputAdornment>,
                            endAdornment: <InputAdornment position="end">
                              <IconButton onClick={() => setshowTempPass(!showTempPass)}>
                                {showTempPass ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>

                          }}
                        />
                      </FormControl>
                    }
                    {(active === 'login' || active === 'forceReset') &&
                      <div className="form__form-group">
                        <FormControl required fullWidth className="height-75">

                          <CssTextField
                            variant="outlined"
                            margin="normal"
                            value={password}
                            onChange={event => setPassword(event.target.value)}
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            autoComplete="current-password"
                            InputProps={{
                              startAdornment: <InputAdornment position="start">
                                <Lock className="black" />
                              </InputAdornment>,
                              endAdornment:
                                <InputAdornment position="end">
                                  <IconButton onClick={() => setshowPassword(!showPassword)}>
                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                  </IconButton>
                                </InputAdornment>
                            }}

                          />

                          {passwordError && (
                            <FormHelperText className="font-size-10 red-color width-375px">
                              {active === 'resetPass' || active === 'forceReset' ? 'Your password must be at least 8 characters long, contain at least one number, one special character and have a mixture of uppercase and lowercase characters.' : 'Phone is invalid'}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </div>}
                    {active === "resetPass" &&
                      <div className="form__form-group">
                        <FormControl required fullWidth className="height-75">

                          <CssTextField
                            variant="outlined"
                            margin="normal"
                            value={password}
                            onChange={event => setPassword(event.target.value)}
                            required
                            fullWidth
                            name="password"
                            label="New Password"
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            autoComplete="current-password"
                            InputProps={{
                              startAdornment: <InputAdornment position="start">
                                <Lock className="black" />
                              </InputAdornment>,
                              endAdornment:
                                <InputAdornment position="end">
                                  <IconButton onClick={() => setshowPassword(!showPassword)}>
                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                  </IconButton>
                                </InputAdornment>
                            }}

                          />

                          {passwordError && (
                            <FormHelperText className="font-size-10 red-color width-375px">
                              {active === 'resetPass' || active === 'forceReset' ? 'Your password must be at least 8 characters long, contain at least one number, one special character and have a mixture of uppercase and lowercase characters.' : 'Phone is invalid'}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </div>
                    }
                    {(active === 'resetPass' || active === 'forceReset') &&
                      <div className="form__form-group">
                        <FormControl required fullWidth className="height-75">

                          <CssTextField
                            variant="outlined"
                            margin="normal"
                            shrink
                            type={showConfirmPass ? 'text' : 'password'}
                            value={confirmPassword}
                            danger={confirmPassError || wrongCreds}
                            onChange={(e) => setconfirmPassword(e.target.value)}
                            placeholder={'Confirm New Password'}
                            onBlur={() => {
                              if (
                                password.length > 0 &&
                                confirmPassword.length > 0 &&
                                password !== confirmPassword
                              ) {
                                setconfirmPassError(true)
                              } else setconfirmPassError(false);
                            }}
                            InputProps={{
                              startAdornment: <InputAdornment position="start">
                                <Lock className="black" />
                              </InputAdornment>,
                              endAdornment:
                                <InputAdornment position="end">
                                  <IconButton onClick={() => setshowConfirmPass(!showConfirmPass)}>
                                    {showConfirmPass ? <Visibility /> : <VisibilityOff />}
                                  </IconButton>
                                </InputAdornment>
                            }}
                          />
                          {confirmPassError && (
                            <FormHelperText className="font-size-10 red-color">
                              {'New password and confirm password must be the same.'}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </div>}
                    <Button
                      type="submit"
                      className={disabled ? 'login-btn-disabled' : 'login-btn'}
                      disabled={disabled}
                      onClick={HandleSubmit}
                    >
                      {active === 'login' ? 'Sign in' : (active === 'resetPass' || active === 'forceReset') ? 'Reset Password' : 'Send Email'}
                      &nbsp;
                  {waiting && <CircularProgress size={15} className="black" />}
                    </Button>
                  </form>
                  <AlignCenter>
                    {active === 'login' ? 'Forgot Password?' : <span className="padding-right-5px">Back to</span>}
                    <Button
                      to={active === 'login' ? '/forgot_password' : '/'}
                      component={Link}
                      onClick={() => {
                        setActive(active === 'login' ? 'forgotPass' : 'login');
                        if (active !== 'login') {
                          history.push('/login')
                        }
                        setwrongCreds(false);
                        // appCtx.dispatch({ type: SET_AUTH_ERROR, error: null })

                      }}
                      className="dark-link"
                    >
                      {' '}<div className="margin-left-m25 font-size-12">{active === 'login' ? 'Reset' : 'Sign In'}</div>
                    </Button>
                  </AlignCenter>
                </div>
              </VerticallyCenter>
            </div>
            <footer className="login-footer">
              <ul className="small-screen-center">
                <div className="flex">
                  <li className="margin-right-26 font-size-12 list-style-none">
                    <a href="https://packagex.app/privacy-policy" target="__blank" className="black margin-m10">
                      Privacy Policy
                </a>
                  </li>
                  <li className="margin-right-26 font-size-12 list-style-none">
                    <a href="https://packagex.app/terms" target="__blank" className="black margin-m10">
                      Terms of Service
                </a>
                  </li>
                  <li className="margin-right-26 font-size-12 list-style-none">
                    <a href="https://packagex.app/support" target="__blank" className="black margin-m10">
                      Contact Us
                </a>
                  </li>
                </div>
              </ul>
              <span className="font-size-12 small-screen-center black">{(() => {
                switch (env && env.includes('cn')) {
                  case true: {
                    return (
                      <div>
                        © {new Date().getFullYear()} InventoryX Inc, (ICP No. 18032187-2).
                      </div>
                    );
                  }
                  default: {
                    return (
                      // <div>© {new Date().getFullYear()} PackageX, Inc.</div>

                      <div>Powered by PackageX, Inc. © {new Date().getFullYear()}. All rights reserved.</div>
                    );
                  }
                }
              })()}
              </span>
            </footer>
          </Paper>
        </Grid>
        <Slider />
      </Grid>

    );
  }
}